var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6261 45.3067V27.6796C18.6784 24.2147 19.414 20.7942 20.7905 17.6141C22.1671 14.4339 24.1576 11.5567 26.6481 9.14717C29.1385 6.73769 32.08 4.84325 35.3039 3.57247C38.5277 2.3017 41.9706 1.67954 45.4353 1.74166C48.9 1.67954 52.343 2.3017 55.5668 3.57247C58.7907 4.84325 61.7321 6.73769 64.2226 9.14717C66.7131 11.5567 68.7037 14.4339 70.0804 17.6141C71.4564 20.7942 72.1923 24.2147 72.2446 27.6796V45.3067",
    stroke: "#EB5757",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57242 35.2531H15.2747C16.1635 35.2531 17.0159 35.6061 17.6443 36.2346C18.2728 36.863 18.6259 37.7154 18.6259 38.6042V58.7111C18.6259 59.5999 18.2728 60.4523 17.6443 61.0807C17.0159 61.7092 16.1635 62.0623 15.2747 62.0623H8.57242C6.79484 62.0623 5.09011 61.3561 3.83318 60.0992C2.57625 58.8423 1.87012 57.1376 1.87012 55.36V41.9554C1.87012 40.1778 2.57625 38.473 3.83318 37.2161C5.09011 35.9592 6.79484 35.2531 8.57242 35.2531Z",
    stroke: "#EB5757",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.298 62.0623H75.5957C74.7069 62.0623 73.8544 61.7092 73.2257 61.0807C72.5977 60.4523 72.2445 59.5999 72.2445 58.7111V38.6042C72.2445 37.7154 72.5977 36.863 73.2257 36.2346C73.8544 35.6061 74.7069 35.2531 75.5957 35.2531H82.298C84.0754 35.2531 85.7805 35.9592 87.0372 37.2161C88.2939 38.473 89.0003 40.1778 89.0003 41.9554V55.36C89.0003 57.1376 88.2939 58.8423 87.0372 60.0992C85.7805 61.3561 84.0754 62.0623 82.298 62.0623Z",
    stroke: "#EB5757",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8396 80.4937C62.3947 80.4937 65.804 79.0815 68.318 76.5675C70.832 74.0535 72.2442 70.644 72.2442 67.0891V52.0089",
    stroke: "#EB5757",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8399 80.4936C58.8399 82.7154 57.9572 84.8468 56.386 86.4178C54.8149 87.9888 52.6839 88.8715 50.462 88.8715H40.4085C38.1866 88.8715 36.0556 87.9888 34.4845 86.4178C32.9133 84.8468 32.0306 82.7154 32.0306 80.4936C32.0306 78.2718 32.9133 76.1405 34.4845 74.5694C36.0556 72.9984 38.1866 72.1157 40.4085 72.1157H50.462C52.6839 72.1157 54.8149 72.9984 56.386 74.5694C57.9572 76.1405 58.8399 78.2718 58.8399 80.4936Z",
    stroke: "#EB5757",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1102 23.7582V35.1504",
    stroke: "#EB5757",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8591 23.7582V35.1504",
    stroke: "#EB5757",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1102 49.6495C34.1102 57.9348 55.859 57.9348 55.859 49.6495",
    stroke: "#EB5757",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.7357319e4df0fa37e2b74c237d458269.svg";
export { ForwardRef as ReactComponent };